import mixpanel from "mixpanel-browser";
import type { Admin } from "./graphql/generated-gql";

export const EVENT_CATEGORIES = {
  NAVIGATION: "navigation",
  INTERACTION: "interaction",
  TRANSACTION: "transaction",
  FORM: "form",
  SYSTEM: "system",
  ADMIN: "admin",
} as const;

export type EventCategory =
  (typeof EVENT_CATEGORIES)[keyof typeof EVENT_CATEGORIES];

export const EVENT_CONTEXTS = {
  ROSTER: "roster",
  PATIENT: "patient",
  APPOINTMENT: "appointment",
  SETTINGS: "settings",
  STOREFRONT: "storefront",
  COMPANION: "companion",
  KIOSK: "kiosk",
  INSURANCE: "insurance",
  PAYMENT: "payment",
  AUTH: "auth",
  MESSAGE: "message",
  INTAKE: "intake",
  LEDGER: "ledger",
  TRANSFERS: "transfers",
  SEARCH: "search",
  MODAL: "modal",
  DROPDOWN: "dropdown",
  ACCOUNT: "account",
  ELIGIBILITY: "eligibility",
} as const;

export type EventContext = (typeof EVENT_CONTEXTS)[keyof typeof EVENT_CONTEXTS];

interface AnalyticsEvent {
  category: EventCategory;
  context: EventContext;
  action: string;
  metadata?: Record<string, unknown>;
}

export function trackEvent({
  category,
  context,
  action,
  metadata = {},
}: AnalyticsEvent) {
  const eventName = `${category}:${context}:${action}`;

  if (isMixpanelLoaded()) {
    mixpanel.track(eventName, metadata);
  }
}

function isMixpanelLoaded() {
  // biome-ignore lint/suspicious/noExplicitAny: analytics
  return (mixpanel as any | undefined)?.__loaded;
}

export function identifyUser(userId: string | undefined) {
  if (isMixpanelLoaded()) {
    mixpanel.identify(userId);
  }
}

export function addAdminToMixpanel(
  admin: Pick<Admin, "email" | "orgId" | "id">,
  practiceId: string,
) {
  if (isMixpanelLoaded()) {
    mixpanel.people.set({
      $email: admin.email,
      $orgId: admin.orgId,
      $adminId: admin.id,
      $practiceId: practiceId,
    });
  }
}
